import React from 'react';

function AgendaPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Agenda</h1>
      <p>Page `fhc-agenda.html` convertie en composant React.</p>
    </div>
  );
}

export default AgendaPage;
